import { combine } from 'react-hooks-combine'

import EventViewComponent from './component'

export const EventView = combine({
  transformProps: ({ match }) => ({
    eventId: Number(match.params.eventId),
  }),
})(EventViewComponent)
